import React, { useState } from "react";
import "../styles/Awards.scss";
import PageTop from "../components/PageTop";
import page_top from "../Img/awards/awards_page_top.jpg";
import HeroCard from "../components/HeroCard";
import img1 from "../Img/awards/awards_page_top.jpg"
import AboutCarousel from "../components/AboutCarousel";
import sliderone from "../Img/gallery-page/18.webp";
import slidertwo from "../Img/gallery-page/29.webp";
import sliderthree from "../Img/gallery-page/01.webp";
import sliderfour from "../Img/gallery-page/36.webp";
import sliderfive from "../Img/gallery-page/17.webp";
import slidersix from "../Img/gallery-page/21.webp";
import sliderseven from "../Img/gallery-page/48.webp";
import img2 from "../Img/awards/aw_img1.jpg"
import img3 from "../Img/awards/aw_img2.jpg"
import img4 from "../Img/awards/aw_img3.jpg"
import img5 from "../Img/awards/aw_img4.jpg"
import img6 from "../Img/awards/aw_img5.jpg"
import img7 from "../Img/awards/aw_img6.jpg"
const Awards = ({ data }) => {
    const achivementimages = [
    sliderone,
    slidertwo,
    sliderthree,
    sliderfour,
    sliderfive,
    slidersix,
    sliderseven,
  ];
        const [imageToShow, setImageToShow] = useState("");
    const [lightboxDisplay, setLightBoxDisplay] = useState(false);
    const [visible, setvisible] = useState(6);

    const images = [img2, img3, img4, img5,img6,img7];
    //looping through our images array to create img elements
    const loadmoreHandler =()=>
    {
        setvisible((prevvalue)=>prevvalue+6)
    }
    const imageCards = images.slice(0, visible).map((image) => (
      <div className="internal_image" style={{backgroundImage:`url(${image})`}}  onClick={() => showImage(image)}>

      </div>
        
    ));
     
    //function to show a specific image in the lightbox, amd make lightbox visible
    const showImage = (image) => {
        setImageToShow(image);
        setLightBoxDisplay(true);
    };

    //hide lightbox
    const hideLightBox = () => {
        setLightBoxDisplay(false);
    };

    //show next image in lightbox
    const showNext = (e) => {
        e.stopPropagation();
        let currentIndex = images.indexOf(imageToShow);
        if (currentIndex >= images.length - 1) {
            setLightBoxDisplay(false);
        } else {
            let nextImage = images[currentIndex + 1];
            setImageToShow(nextImage);
        }
    };

    //show previous image in lightbox
    const showPrev = (e) => {
        e.stopPropagation();
        let currentIndex = images.indexOf(imageToShow);
        if (currentIndex <= 0) {
            setLightBoxDisplay(false);
        } else {
            let nextImage = images[currentIndex - 1];
            setImageToShow(nextImage);
        }
    };
    const showLoadMoreButton = images.length > visible;
  return (
    <>
      {data.map((data, index) => {
        return (
          <div key={index}>
            <PageTop
              text={data.aw_title}
              url={page_top}
              bgPostiion="top center"
            />

            <HeroCard
            align="row"
            url={page_top}
            desc={data.aw_hc_desc}
              span={data.aw_hc_span}
              title={data.aw_hc_title}
            />
            <div class="awrd_gallery parent">
               <h1  className="container-large">
                   {data.aw_hc_ph_title} <span> {data.aw_hc_ph_title_span} </span>
                  </h1>
              <div class="awrd_gallery_cont container-large">
               
                   {imageCards}
            {
                lightboxDisplay ?
                    <div id="lightbox" onClick={hideLightBox}>
                        <button className="gallery-btn" onClick={showPrev}>⭠</button>
                        <img id="lightbox-img" src={imageToShow} alt="imageToShow" />
                        <button className="gallery-btn" onClick={showNext}>⭢</button>
                    </div>
                    : ""
            }
              </div>
            </div>
             <div className="about-slider parent">
              <div className="aboutslider-container container-small">
                <h2>
                  {" "}
                  {data.AP_slider_title}{" "}
                  <span>{data.AP_slider_title_span}</span>
                </h2>
                <div className="slider-box">
                  
                  <AboutCarousel images={achivementimages} />
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Awards;
